import { Link } from 'react-router-dom';

export default function ArticleHero() {
  return (
    <section className="relative w-full bg-gray-900 pt-36 pb-24 flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900/40"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-teal-400/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-teal-500/10 rounded-full blur-2xl"></div>
      <div className="relative z-10 text-center w-full max-w-4xl mx-auto px-6">
        {/* Breadcrumb */}
        <div className="flex items-center justify-center gap-2 text-sm text-white/50 mb-6">
          <Link to="/blog" className="hover:text-teal-400 transition-colors cursor-pointer">Blog</Link>
          <i className="ri-arrow-right-s-line text-white/30"></i>
          <span className="text-white/70">Stretch Tents</span>
        </div>

        {/* Category tag */}
        <span className="inline-block px-4 py-1.5 bg-teal-400/20 text-teal-300 text-xs font-bold rounded-full mb-5 tracking-wide uppercase">
          Stretch Tents
        </span>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight tracking-tight">
          Enhance Your Festival&apos;s Appeal: Strategic Uses of Stretch Tents for Better Guest Experience
        </h1>

        <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto font-light leading-relaxed">
          Learn how strategically placed stretch tents can improve crowd flow, shelter, and the overall festival atmosphere, turning any outdoor event into an immersive, memorable experience.
        </p>

        {/* Meta */}
        <div className="flex items-center justify-center gap-6 mt-8 text-sm text-white/50">
          <span className="flex items-center gap-1.5">
            <i className="ri-calendar-line text-teal-400"></i>
            Feb 18, 2026
          </span>
          <span className="w-1 h-1 bg-white/20 rounded-full"></span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line text-teal-400"></i>
            5 mins read
          </span>
          <span className="w-1 h-1 bg-white/20 rounded-full"></span>
          <span className="flex items-center gap-1.5">
            <i className="ri-user-line text-teal-400"></i>
            Pop Pro Tents Team
          </span>
        </div>
      </div>
    </section>
  );
}
